import React from 'react'
import { privacy } from '../../../../content/site'

// Privacy Policy body, on the new design system (Task 11). This is a reading document, not
// a marketing page - a single narrow column (~68ch) of prose, no cards, no icons, no
// two-column layout, per the task brief. Every section/list item is copied verbatim from
// the old src/pages/public/privacypolicy/content/index.jsx (git 8cc2307), eight headed
// blocks in the same order; the source carries no clause numbers, so none is added here.
const Index = () => {
  return (
    <section className="section privacy-section">
      <div className="container privacy-container">
        {privacy.sections.map((s) => (
          <div className="privacy-block" key={s.key}>
            <h2 className="privacy-heading">{s.title}</h2>
            {Array.isArray(s.paragraph)
              ? s.paragraph.map((p, i) => <p className="privacy-text" key={i}>{p}</p>)
              : <p className="privacy-text">{s.paragraph}</p>}
            {s.list && (
              <ul className="privacy-list">
                {s.list.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}

export default Index
